import { CKEditor5 } from "./CKEditor5";
export default CKEditor5;
export * from "./CKEditor5";
